import React, { useContext } from 'react'
import { Tooltip } from '@mui/material'
import { StyledIconButton, StyledIcon } from '../styles'
import { faStrikethrough } from '@fortawesome/pro-solid-svg-icons'
import ToolsMenuItem from './ToolsMenuItem'
import { QuestionContextMenuContext } from '@app/components/common/QuestionContextMenuContext'

export type Props = {
  isReviewMode: boolean
  isMobile?: boolean
}

const Strikethrough: React.FC<Props> = ({ isReviewMode, isMobile = false }) => {
  const context = useContext(QuestionContextMenuContext)
  const { strikethroughEnabled = false, toggleStrikethroughEnabled = () => {} } = context ?? {}
  if (isReviewMode) return null

  return isMobile ? (
    <ToolsMenuItem
      icon={faStrikethrough}
      label='Strikethrough'
      checked={strikethroughEnabled}
      onChange={toggleStrikethroughEnabled}
    />
  ) : (
    <Tooltip title='Strikethrough'>
      <StyledIconButton
        aria-label='Strikethrough'
        aria-pressed={strikethroughEnabled}
        onClick={toggleStrikethroughEnabled}
        className={strikethroughEnabled ? 'active' : ''}
      >
        <StyledIcon icon={faStrikethrough} />
      </StyledIconButton>
    </Tooltip>
  )
}

export default Strikethrough
